export default __webpack_public_path__ + "static/media/sushi-box-mix.d5d7c4f2.jpg";